export default {"src":"/_next/static/media/guidance.ddc58600.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};